import axios from 'axios'
import { host } from '../../helper/config'

const PLUGINS_NAME = 'admin-admins'

export const getAllAdmins = async (token, payload = {}) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/get-all`, payload, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      Authorization: token
    }
  })

  if (response && response.status === 200) {
    return response.data || {}
  }

  return null
}

export const createAdmin = async (token, payload) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/create`, payload, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      Authorization: token
    }
  })

  if (response && response.status === 201) {
    return response.data || {}
  }

  return null
}

export const updateAdmin = async (token, payload) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/update`, payload, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      Authorization: token
    }
  })

  if (response && response.status === 200) {
    return response.data || {}
  }

  return null
}

